import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import loginLogEsCL from './locales/es-CL.json';
import loginLogEnUS from './locales/en-US.json';
import loginLogPtBR from './locales/pt-BR.json';

export const loginLogI18n = buildScopedI18n({
  esCL: loginLogEsCL,
  enUS: loginLogEnUS,
  ptBR: loginLogPtBR,
});
